import { render, staticRenderFns } from "./StudentListItem.vue?vue&type=template&id=9c586c56&scoped=true&"
import script from "./StudentListItem.vue?vue&type=script&lang=js&"
export * from "./StudentListItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentListItem.vue?vue&type=style&index=0&id=9c586c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c586c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VListItem,VRow,VSwitch})
